.dh-mfc {
    @media (max-width: 720px) {
        .selectors__left--padding {
            padding-left: 1px!important;
        }

        .container-selectors {
            max-height: 300px;
            overflow: auto;
            padding-top: 25px;
            position: relative;
        }

        .gradient-hide {
            display: none;
        }

        .gradient-show,
        .gradient-audi {
            display: block;
            height: 75px;
            position: absolute;
            width: 100%;
            bottom: 0;
            left: 0;
            z-index: 100;
            background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,.3) 98%);
        }
    }
}